var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#545562;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{opacity:0.1;}\n\t.st2{fill:#010101;}\n\t.st3{fill:#F5EA84;}\n\t.st4{fill:#724C50;}\n\t.st5{opacity:0.1;fill:#010101;enable-background:new    ;}\n\t.st6{fill:#6E9EC5;}\n\t.st7{fill:#81A9CC;}\n\t.st8{fill:#EBEBEB;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{opacity:5.000000e-02;fill:#010101;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M447.3,369.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471,221.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450.4,154.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.3,228.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502.2,172"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.7,298.2c0,0-11.5,9-20.7-22.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.2,316.6c0,0,23.4-3.1,25.6-17.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.4,377.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.9,162.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M546.8,209.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.2,155.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.4,172.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489,297.9c0,0,48.1-1.7,50.9-23.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.2,319.7c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3,0.2-0.6,0.3-0.9,0.4C249.3,319.9,249.7,319.8,250.2,319.7z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.5,208.2h263.2v263.1H277.5V208.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.4,441.7l20.1-12.2c3.9,6.9,7.4,12.7,15.9,12.7c8.1,0,13.3-3.2,13.3-15.5v-84.1h24.7v84.4 c0,25.6-15,37.3-36.9,37.3C387.8,464.3,376.3,454.1,370.4,441.7 M457.9,439.1l20.1-11.7c5.3,8.7,12.2,15,24.4,15 c10.3,0,16.8-5.1,16.8-12.2c0-8.5-6.7-11.5-18-16.4l-6.2-2.6c-17.8-7.6-29.7-17.1-29.7-37.3c0-18.5,14.1-32.7,36.2-32.7 c15.7,0,27,5.5,35.2,19.8l-19.3,12.4c-4.2-7.6-8.8-10.6-15.9-10.6c-7.2,0-11.8,4.6-11.8,10.6c0,7.4,4.6,10.4,15.2,15l6.2,2.6 c21,9,32.9,18.2,32.9,38.9c0,22.3-17.5,34.5-41,34.5C479.9,464.3,465.1,453.3,457.9,439.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M660.3,407.3l-6.8,0.5l-3.6,0.2v-8.6l4.7-0.9l2.9-0.5c0,0,9-26.6,17.6-21.8S660.3,407.3,660.3,407.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M653.5,407.8l-3.6,0.2v-8.6l4.7-0.9C652.9,400.7,653,404.5,653.5,407.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M716.2,267.4L701,438.1l-68.5,19l-68.3-19l-15.2-170.7H716.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M642.9,442.8l55.3-15.3l13-145.9h-68.3V442.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M612.1,321.2h29.6v-20.9h-52.5l0.5,5.6l5.2,57.7h46.9v-20.9H614L612.1,321.2z M616.8,374.1h-21l2.9,32.9 l42.8,11.9h0.1V397h-0.1l-23.3-6.3L616.8,374.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M579.8,220.1h10.6v10.5h9.7v-10.5h10.6V252h-10.6v-10.7h-9.7V252h-10.6V220.1z M624.8,230.7h-9.4v-10.6h29.4 v10.6h-9.4V252h-10.6L624.8,230.7L624.8,230.7L624.8,230.7z M649.5,220.1h11.1l6.8,11.2l6.8-11.2h11.1V252h-10.6v-15.8l-7.3,11.3 h-0.2l-7.3-11.3V252h-10.4V220.1z M690.7,220.1h10.6v21.3h15V252h-25.6L690.7,220.1L690.7,220.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M641.2,363.6H667l-2.4,27.2l-23.3,6.3v21.8l42.9-11.9l0.3-3.5l4.9-55.1l0.5-5.6h-48.7V363.6L641.2,363.6z  M641.2,321.2L641.2,321.2l50.6,0l0.4-4.7l1-10.6l0.5-5.6h-52.5V321.2L641.2,321.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M172,468.3l-82.9-23L70.6,238h203.1l-18.5,207.3L172,468.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242.7,431l18.5-177.9h-83l-2.7,196.5L242.7,431z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M127.6,327.2l2.3,25.4h56.9v-25.4H127.6z M123.1,275.8l2.3,25.4h61.4v-25.4L123.1,275.8L123.1,275.8z  M186.8,393.3h-0.1l-28.3-7.7l-1.8-20.3H131l3.6,39.9l52.1,14.5h0.1L186.8,393.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.1,188h30.8v12.9H127v12.9h17.9v12.9h-30.8V188z M151.1,188h30.8v11.2h-18v2.2h17.9v25.8h-30.8v-11.8H169 v-2.2h-17.9L151.1,188L151.1,188z M188.1,188h30.8v11.2h-18v2.2h17.9v25.8H188v-11.8h17.9v-2.2H188V188H188.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M245.6,327.2l4.6-51.5h-63.7v25.4h35.8l-2.3,26h-33.5v25.4h31.3l-3,33l-28.3,7.7v26.5l52.1-14.5l0.4-4.3l6-66.9 L245.6,327.2L245.6,327.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M135.3,486.2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M157.6,474.8c3.2-0.4,5.3-0.7,5.3-0.7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.9,391.4c1.1,1.6,2.1,3.2,3,4.9c1.5,0.3,3,0.5,4.5,0.5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.5,384.8c-0.3-3.8,2.8-3.9,4-8.2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M140.1,415.7c-0.4-0.4-3.7,0.3-5.8,0.7c0.3-1.2,0.6-2.4,0.7-3.6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.4,512.9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.6,419.4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe2b17e4062a5459487e60bcf426e641.svg";
export { ForwardRef as ReactComponent };